import { render } from "./CommitteeSection.vue?vue&type=template&id=30c357cf"
import script from "./CommitteeSection.vue?vue&type=script&lang=js"
export * from "./CommitteeSection.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__